<template>
    <div class="restrunt_menu_basket" v-if="basket.amount && parseInt(basket.amount) !==0">
        <div class="cart-list-wrapper" v-for="(restaurant, restaurant_id) in basket.basket" :key="restaurant_id"  style="margin-bottom: 15px;">
            <h3>{{restaurant.name}}</h3>
            <div class="product__cart-logo">
                <router-link :to="'/restaurant/' + restaurant.id">
                    <img :src="restaurant.logo" alt="">
                </router-link>
            </div>
            <div class="basket_dish" v-for="product in restaurant.products" :key="product.id">
                <div class="dish_description">
                    <p>{{product.category}}</p>
                    <h2>{{product.name}}</h2>
                    <span>{{product.price}}</span>
                </div>
                <div class="dish_counter">
                    <div class="number">
                        <span class="minus" @click="minusBasket(product.id)">-</span>
                        <input type="text" :value="product.quantity"/>
                        <span class="plus" @click="plusBasket(product.id)">+</span>
                    </div>
                    <div class="dish_cancel" @click="removeBasket(product.id)">
                        <span>x</span>
                    </div>
                </div>

            </div>
            <div class="restaurant_notice" v-if="parseInt(restaurant.minimal) > parseInt(restaurant.amount)">
                <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/warning.svg" alt="">
                <p>Внимание! У ресторана “{{restaurant.name}}” минимальная сумма заказа {{restaurant.minimal}}. Вам необходимо дозаказать ещё на {{(parseInt(restaurant.minimal) - parseInt(restaurant.amount))}} {{basket.valute}}</p>
            </div>
            <div class="restaurant_notice" v-if="parseInt(restaurant.free) !== 0 && parseInt(restaurant.free) > parseInt(restaurant.amount) || parseInt(restaurant.free) === 0">
                <p>У ресторана “{{restaurant.name}}” доставка - {{restaurant.delivery_price}}</p>
            </div>
        </div>
        <div class="restrunt_menu_basket_inner">
            <div class="total_amount">
                <span>Итого:</span>
                <span class="total_amount_value" >{{basket.amount}}</span>
            </div>
            <router-link tag="button" to="/cart" class="basket_btn primary" >КОРЗИНА</router-link>
        </div>
    </div>
</template>

<script>
import axios from '@/router/http'
export default {
  name: 'cartSidebar',
  props: ['basket', 'auth'],
  methods: {
    plusBasket (id) {
      var formData = new FormData()
      formData.append('id', id)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/plus-in-basket',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.$root.basketUpdate = 1
      })
    },
    minusBasket (id) {
      var formData = new FormData()
      formData.append('id', id)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/minus-in-basket',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.$root.basketUpdate = 1
      })
    },
    removeBasket (id) {
      var formData = new FormData()
      formData.append('id', id)
      formData.append('all', 1)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/minus-in-basket',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.$root.basketUpdate = 1
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cartSidebar.vue